import React from "react";
import PropTypes from "prop-types";
import { ComponentsSlider } from "../ComponentsSlider";

const CardsSlider = ({
	classNames,
	cards,
	CardComponent,
	navigationType,
	paginationType,
	link,
	renderLink,
	boxShadow,
}) => {
	const slides = cards.map(({ id, ...props }) => ({
		id,
		view: <CardComponent {...props} />,
	}));

	return (
		<ComponentsSlider
			classNames={classNames}
			slides={slides}
			navigationType={navigationType}
			paginationType={paginationType}
			link={link}
			renderLink={renderLink}
			boxShadow={boxShadow}
			breakpoints={{
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 3,
				},
			}}
			slidesPerView={1}
		/>
	);
};

CardsSlider.propTypes = {
	classNames: PropTypes.shape({
		swiper: PropTypes.string,
		slide: PropTypes.string,
	}),
	/**
	 * Each object in the array is passed into the provided CardComponent - only `id` is required.
	 */
	cards: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
		}).isRequired
	).isRequired,
	/**
	 * Any component may be used - each object in the `cards` array will be passed into this component
	 */
	CardComponent: PropTypes.elementType.isRequired,
	navigationType: PropTypes.oneOf([true, false, "desktopOnly"]),
	paginationType: PropTypes.oneOf([true, false, "desktopOnly"]),
	link: PropTypes.shape({
		text: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
	}),
	renderLink: PropTypes.func,
	boxShadow: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
		PropTypes.shape({
			x: PropTypes.number,
			y: PropTypes.number,
			blur: PropTypes.number,
			spread: PropTypes.number,
			opacity: PropTypes.number,
		}),
	]),
};

CardsSlider.defaultProps = {
	classNames: undefined,
	navigationType: true,
	paginationType: "desktopOnly",
	link: undefined,
	renderLink: (link, { className, children }) => (
		<a href={link.url} target={link.target} className={className}>
			{children}
		</a>
	),
	boxShadow: {
		x: 0,
		y: 7,
		blur: 21,
		opacity: 0.129,
	},
};

export default CardsSlider;
export { CardsSlider };
